export default __webpack_public_path__ + "static/media/flag-balearic-islands.52f8bd33.svg";